class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.loaded = Boolean(this.querySelector('.mini-cart'));
  }

  connectedCallback() {
    this.drawer = document.querySelector('cart-drawer');
    this.whenReady = this.loaded ? Promise.resolve() : this.loadSection();
  }

  loadSection() {
    if (!this.dataset.url) {
      return Promise.resolve();
    }

    return fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const section = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section');

        if (!section) return;

        this.innerHTML = section.innerHTML;
        this.loaded = true;
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer?.querySelector('details');
    if (!detailsElement || detailsElement.hasAttribute('open')) {
      return;
    }

    this.whenReady.then(() => {
      this.drawer.openMenuDrawer();
    });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
    this.loaded = true;
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
